import {
  uploadStart,
  uploadSuccess,
  uploadFailure,
  uploadHistoryStart,
  uploadHistorySuccess,
  uploadHistoryFailure,
  uploadProgressStart,
  uploadProgressSuccess,
  uploadProgressFailure,
} from './mile.slice';
import { uploadFileApi, listUploadHistoryApi, getUploadProgressMultipleApi } from '../api/mile.api';

export const uploadFile = (formData) => async (dispatch) => {
  dispatch(uploadStart());
  try {
    const response = await uploadFileApi(formData);
    dispatch(uploadSuccess(response.data));
    return response.data;
  } catch (error) {
    dispatch(uploadFailure(error.response.data));
  }
};

export const listUploadHistory = (companyID) => async (dispatch) => {
  dispatch(uploadHistoryStart());
  try {
    const response = await listUploadHistoryApi(companyID);
    dispatch(uploadHistorySuccess(response.data));
    return response.data;
  } catch (error) {
    dispatch(uploadHistoryFailure(error.response.data));
  }
};

export const getUploadProgressMultiple = (uploadHistoryIds) => async (dispatch) => {
  dispatch(uploadProgressStart());
  try {
    const response = await getUploadProgressMultipleApi(uploadHistoryIds);
    dispatch(uploadProgressSuccess());
    return response.data;
  } catch (error) {
    const errorMessage =
      error.response?.data?.message || error.message || 'Failed to fetch upload progress';
    dispatch(uploadProgressFailure({ message: errorMessage }));
    throw error;
  }
};
